/* OnseHome — minimal vanilla JS. No dependencies. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  /* ---------------------------------------------------------------------
   * Drawers (menu, cart)
   * ------------------------------------------------------------------- */
  var activeDrawer = null;

  function openDrawer(drawer, trigger) {
    if (!drawer || drawer === activeDrawer) return;
    if (activeDrawer) closeDrawer(activeDrawer, true);
    drawer.hidden = false;
    drawer._trigger = trigger || document.activeElement;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    document.body.classList.add('drawer-open');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    activeDrawer = drawer;
    var first = drawer.querySelector('[data-drawer-close]') || drawer.querySelector(FOCUSABLE);
    setTimeout(function () { if (first) first.focus(); }, reduceMotion ? 0 : 200);
  }

  function closeDrawer(drawer, silent) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var done = function () {
      drawer.hidden = true;
      if (!silent) document.body.classList.remove('drawer-open');
      if (activeDrawer === drawer) activeDrawer = null;
      if (!silent && drawer._trigger && drawer._trigger.focus) drawer._trigger.focus();
    };
    if (reduceMotion) done(); else setTimeout(done, 260);
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(document.getElementById(openBtn.getAttribute('data-drawer-open')), openBtn);
      return;
    }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      var d = closeBtn.closest('[data-drawer]');
      if (d) { if (closeBtn.tagName !== 'A') e.preventDefault(); closeDrawer(d); }
      return;
    }
    if (e.target.matches('[data-drawer]')) closeDrawer(e.target);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (activeDrawer) { closeDrawer(activeDrawer); return; }
      closeAllDropdowns();
    }
    if (e.key === 'Tab' && activeDrawer) {
      var nodes = Array.prototype.filter.call(activeDrawer.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------------------------------------------------------------
   * Header dropdown (Shop)
   * ------------------------------------------------------------------- */
  function closeAllDropdowns() {
    document.querySelectorAll('[data-dropdown].is-open').forEach(function (item) {
      item.classList.remove('is-open');
      var t = item.querySelector('[data-dropdown-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('[data-dropdown]').forEach(function (item) {
    var toggle = item.querySelector('[data-dropdown-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-dropdown]')) closeAllDropdowns();
  });

  /* Header shadow on scroll */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------------
   * Quantity steppers (product form)
   * ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn || btn.hasAttribute('data-cart-change')) return;
    var input = btn.closest('[data-qty]').querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------
   * Cart (AJAX) + drawer re-render via Section Rendering API
   * ------------------------------------------------------------------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartBusy = false;

  function cartUrl(path) {
    return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + path;
  }

  function renderCartDrawer(html) {
    if (!cartDrawer || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawer');
    if (!fresh) return false;
    cartDrawer.innerHTML = fresh.innerHTML;
    var countEl = cartDrawer.querySelector('[data-cart-item-count]');
    var count = countEl ? parseInt(countEl.getAttribute('data-cart-item-count'), 10) : 0;
    updateCartCount(count);
    return true;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    var label = document.querySelector('[data-cart-count-label]');
    if (label) label.textContent = count + ' artikelen in winkelwagen';
  }

  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ sections: 'cart-drawer', sections_url: window.location.pathname }, body))
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) throw json;
        return json;
      });
    });
  }

  function addToCart(form) {
    if (cartBusy) return Promise.resolve();
    var submit = form.querySelector('[data-add-to-cart]');
    var errorEl = form.querySelector('[data-form-error]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || idInput.disabled || !idInput.value || (submit && submit.disabled)) return Promise.resolve();
    var items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }];

    cartBusy = true;
    if (submit) { submit.classList.add('is-loading'); submit.setAttribute('aria-busy', 'true'); }
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    return cartRequest(cartUrl('cart/add.js'), { items: items })
      .then(function (json) {
        if (!renderCartDrawer(json.sections && json.sections['cart-drawer'])) {
          window.location.assign(cartUrl('cart'));
          return;
        }
        openDrawer(cartDrawer, submit);
        document.dispatchEvent(new CustomEvent('cart:added', { detail: json }));
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Er ging iets mis. Probeer het opnieuw.';
        errorEl = errorEl || (cartDrawer && cartDrawer.querySelector('[data-cart-error]'));
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      })
      .finally(function () {
        cartBusy = false;
        if (submit) { submit.classList.remove('is-loading'); submit.removeAttribute('aria-busy'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  function changeLine(line, quantity) {
    if (!cartDrawer || cartBusy) return;
    cartBusy = true;
    var errorEl = cartDrawer.querySelector('[data-cart-error]');
    if (errorEl) errorEl.hidden = true;
    cartDrawer.classList.add('is-busy');
    cartRequest(cartUrl('cart/change.js'), { line: line, quantity: quantity })
      .then(function (json) {
        if (!renderCartDrawer(json.sections && json.sections['cart-drawer'])) window.location.assign(cartUrl('cart'));
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = (err && (err.description || err.message)) || 'Wijzigen is niet gelukt. Controleer je winkelwagen en probeer opnieuw.';
          errorEl.hidden = false;
        }
      })
      .finally(function () { cartBusy = false; cartDrawer.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(parseInt(btn.getAttribute('data-line'), 10), parseInt(btn.getAttribute('data-qty-value'), 10));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---------------------------------------------------------------------
   * Product: variants, gallery, sticky add-to-cart
   * ------------------------------------------------------------------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    if (!form) return;
    var variantsScript = section.querySelector('[data-variants]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = form.querySelector('[data-add-label]');
    var stickyBar = section.querySelector('[data-sticky-atc]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickySubmit = section.querySelector('[data-sticky-submit]');

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]:checked').forEach(function (i) { opts[parseInt(i.getAttribute('data-option-index'), 10)] = i.value; });
      return opts;
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      section.querySelectorAll('.gallery__slide').forEach(function (s) {
        var active = s.getAttribute('data-media-id') === String(mediaId);
        s.hidden = !active;
        s.classList.toggle('is-active', active);
      });
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        var active = t.getAttribute('data-target') === String(mediaId);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updateVariant() {
      if (!variants) return;
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var available = !!(variant && variant.available);
      idInput.disabled = !available;
      if (!variant) idInput.value = '';
      var payment = form.querySelector('[data-dynamic-checkout]');
      if (payment) payment.hidden = !available;
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) {
          var html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> ';
          }
          html += '<span class="price__current">' + formatMoney(variant.price) + '</span>';
          priceEl.innerHTML = '<div class="price' + (available ? '' : ' price--sold-out') + '">' + html + '</div>';
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      if (addBtn) addBtn.disabled = !available;
      if (stickySubmit) stickySubmit.disabled = !available;
      if (stickySubmit) stickySubmit.textContent = !variant ? 'Niet beschikbaar' : (available ? 'In winkelwagen' : 'Uitverkocht');
      if (addLabel) addLabel.textContent = !variant ? 'Niet beschikbaar' : (available ? 'In winkelwagen' : 'Uitverkocht');
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) updateVariant();
    });

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) showMedia(thumb.getAttribute('data-target'));
    });

    if (stickyBar && addBtn) {
      var ticking = false;
      var updateSticky = function () {
        stickyBar.hidden = addBtn.getBoundingClientRect().bottom >= 0;
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(updateSticky); }
      }, { passive: true });
      updateSticky();
      if (stickySubmit) stickySubmit.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
      });
    }
  });

  /* ---------------------------------------------------------------------
   * Related products (recommendations API)
   * ------------------------------------------------------------------- */
  document.querySelectorAll('[data-related-products]').forEach(function (wrap) {
    var url = wrap.getAttribute('data-url');
    if (!url) return;
    var load = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-related-products]');
        if (fresh && fresh.innerHTML.trim()) wrap.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px 0px' });
      io.observe(wrap);
    } else {
      load();
    }
  });

  /* Country select default (addresses) */
  document.querySelectorAll('select[data-default]').forEach(function (sel) {
    var def = sel.getAttribute('data-default');
    if (def) sel.value = def;
  });

  window.OnseHome = { openDrawer: openDrawer, closeDrawer: closeDrawer, addToCart: addToCart };
})();
